export function formatDate(dateStr: string) {
  const now = new Date()
  const serverDate = new Date(dateStr)
  const date = new Date(serverDate.getTime() + serverDate.getTimezoneOffset() * 60_000)

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  const dayBeforeYesterday = new Date(today)
  dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2)
  const messageDate = new Date(date.getFullYear(), date.getMonth(), date.getDate())

  if (messageDate.getTime() === today.getTime()) return "Сегодня"
  if (messageDate.getTime() === yesterday.getTime()) return "Вчера"
  if (messageDate.getTime() === dayBeforeYesterday.getTime()) return "Позавчера"

  const options: Intl.DateTimeFormatOptions =
    date.getFullYear() === now.getFullYear() ? { day: "numeric", month: "long" } : { day: "numeric", month: "long", year: "numeric" }

  return date.toLocaleDateString("ru-RU", options)
}

export function formatTime(dateStr: string) {
  const serverDate = new Date(dateStr)
  const date = new Date(serverDate.getTime() + serverDate.getTimezoneOffset() * 60_000)
  return date.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit", hour12: false })
}
